// @flow
import xws from 'api/xws/';
import qs from 'query-string';

// Constants
import { getService } from 'constants/ajax';

export default function lostUserNameWS(data: {|
  tokenId: string,
  webKey: string,
  email: string
|}): Promise<any> {
  const loginService = getService('lostUserName');
  return xws(loginService).post(loginService.getPath(), qs.stringify(data));
}



// WEBPACK FOOTER //
// ./src/api/xws/login/lostUserNameWs.js